import { rcaptureAny } from './rcapture-any.js';
/**
 * Route matcher that matches any part of the entry name.
 */
export const rmatchAny = /*#__PURE__*/ rcaptureAny();
//# sourceMappingURL=rmatch-any.js.map